<p class="loginHeadingText text-start pt-1">VALIDATION CRITERIA</p>

<div class="row">
    <div class="col-md-1">
        <label>QUESTIONS</label>
    </div>

    <div class="col-md-11 ps-0">
        <table class="table datatable border-x-0 mb-4">
            <thead>
                <tr class="subheaderrr">
                    <th width="15%">CRITERIA TYPE</th>
                    <th width="25%">CRITERIA</th>
                    <th width="15%">RESPONSE TYPE</th>
                    <th width="30%">RESPONSE</th>
                    <th width="10%" class="border-end-0">ACTION</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <!-- Criteria Type -->
                    <td [ngClass]="parentCol">
                        <select class="form-select" aria-label="Select Criteria Type" [disabled]="disableAfterReview"
                            [(ngModel)]="selectedCriteriaType" (ngModelChange)="onCriteriaTypeChange($event)">
                            <option [ngValue]="null" disabled selected>Select Criteria Type</option>
                            <option *ngFor="let type of criteriaTypes" [value]="type">{{ type }}</option>
                        </select>
                    </td>

                    <!-- Criteria Input / Dropdown -->
                    <td [ngClass]="parentCol">
                        <ng-container *ngIf="selectedCriteriaType === 'Standard'; else customCriteria">
                            <!-- Standard Criteria -->
                            <select class="form-select" *ngIf="!isPartialCriteriaText" [(ngModel)]="selectedCriteria"
                                (ngModelChange)="onCriteriaDropdownUpdate($event)">
                                <option [ngValue]="null" disabled selected>Select Criteria</option>
                                <option *ngFor="let option of criteriaList" [ngValue]="option">
                                    {{ option.criteriaText }}
                                </option>
                            </select>

                            <!-- Partial Editable Text -->
                            <div *ngIf="isPartialCriteriaText" class="d-flex flex-wrap align-items-center">
                                <ng-container *ngFor="let part of splitPartialCriteriaText; let i = index">
                                    <span *ngIf="!part.isInput">{{ part.text }}</span>
                                    <ng-container *ngIf="part.isInput">
                                        <input type="text" class="form-control d-inline-block mx-1"
                                            style="width: auto; min-width: 150px;" maxlength="1000"
                                            [(ngModel)]="partialInputValue[getInputIndex(i)]"
                                            [placeholder]="part.placeholder" [disabled]="disableAfterReview" />
                                    </ng-container>
                                </ng-container>
                            </div>

                        </ng-container>

                        <!-- Custom Criteria -->
                        <ng-template #customCriteria>
                            <input class="form-control" type="text" placeholder="Enter Criteria" maxlength="1000"
                                [(ngModel)]="customCriteriaText" [disabled]="disableAfterReview" />
                        </ng-template>
                    </td>

                    <!-- Response Type -->
                    <td [ngClass]="parentCol">
                        <ng-container *ngIf="selectedCriteriaType !== 'Standard'; else standardResponseType">
                            <select class="form-select" aria-label="Select Response Type"
                                [(ngModel)]="selectedResponseType" [disabled]="disableAfterReview">
                                <option [ngValue]="null" disabled selected>Select Response Type</option>
                                <option *ngFor="let resp of responseDropdownValues" [value]="resp">{{ resp }}</option>
                            </select>
                        </ng-container>
                        <ng-template #standardResponseType>
                            <span>{{ selectedResponseType }}</span>
                        </ng-template>
                    </td>

                    <!-- Response Values -->
                    <td [ngClass]="parentCol">
                        <!-- Predefined Responses (Standard) -->
                        <div
                            *ngIf="selectedCriteriaType === 'Standard' && (selectedCriteria?.responses?.length ?? 0) > 0">
                            <span>{{ getCommaSeparatedResponses() }}</span>
                        </div>

                        <!-- Custom Responses Input -->
                        <div
                            *ngIf="selectedCriteriaType === 'Standard' && (selectedCriteria?.responses?.length ?? 0) === 0">
                            <div *ngFor="let response of customResponses; let i = index; trackBy: trackByIndex"
                                class="d-flex align-items-center mb-1">
                                <input class="form-control me-2" type="text" [(ngModel)]="customResponses[i]"
                                    maxlength="400" placeholder="Enter Response" />

                                <img src="assets/images/plus_icon.svg" alt="Add" title="Add Response"
                                    (click)="addResponse()" class="cursor-pointer" />

                                <img *ngIf="customResponses.length > 1" src="assets/images/close_mark.svg" alt="Remove"
                                    title="Remove Response" (click)="removeResponse(i)" class="cursor-pointer ms-2" />
                            </div>
                        </div>
                    </td>

                    <!-- Action Button -->
                    <td>
                        <button class="btn progressBtn ps-2 me-2" (click)="addValidationCriteria()">
                            {{ selectedAction }} CRITERIA
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- List of Added Criteria -->
<div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-11 ps-0">
        <table class="table datatable border-x-0 mb-4">
            <thead>
                <tr class="subheaderrr">
                    <th width="15%">CRITERIA TYPE</th>
                    <th width="25%">CRITERIA</th>
                    <th width="15%">RESPONSE TYPE</th>
                    <th width="30%">RESPONSE</th>
                    <th width="10%" class="border-end-0">ACTION</th>
                </tr>
            </thead>
            <tbody>
                <!-- No Criteria Message -->
                <tr *ngIf="validationCriterias.length === 0">
                    <td colspan="5" class="text-center text-muted">No validation criteria available.</td>
                </tr>

                <!-- Criteria Rows -->
                <ng-container *ngFor="let row of validationCriterias; let i = index">
                    <tr>
                        <td [ngClass]="parentCol">
                            {{ row.responseType === 'Dropdown' ? 'Standard' : 'Custom' }}
                        </td>
                        <td [ngClass]="parentCol">
                            {{ row.criteriaText }}
                        </td>
                        <td [ngClass]="parentCol">
                            {{ row.responseType }}
                        </td>
                        <td [ngClass]="parentCol">
                            {{ row.responsesText }}
                        </td>
                        <td [ngClass]="parentCol">
                            <img src="assets/images/pencilIocn.svg" alt="Edit" title="Edit"
                                (click)="editValidationCriteria(row)" class="me-2" style="cursor: pointer;" />

                            <img src="assets/images/close_mark.svg" alt="Delete" title="Delete"
                                (click)="deleteCriteria(i, row)" style="cursor: pointer;" />
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>

<br />